/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { constraint_item_types } from './constraint_item_types';
import type { constraint_scopes } from './constraint_scopes';
export type constraint_modifier_condition_full = {
  name: string;
  field: constraint_modifier_condition_full.field;
  scope: constraint_scopes;
  value: string;
  percent_value: boolean;
  shared: boolean;
  include_child_selections: boolean;
  include_child_forces: boolean;
  child_id: number | null;
  child_type: constraint_item_types | null;
  limit: constraint_modifier_condition_full.limit;
};
export namespace constraint_modifier_condition_full {
  export enum field {
    SELECTIONS = 'Selections',
    POINT = 'Point',
  }
  export enum limit {
    AT_LEAST = 'AtLeast',
    EQUAL_TO = 'EqualTo',
    AT_MOST = 'AtMost',
  }
}
